// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1981":"7c7a9bba","6392":"b984105f","8835":"7c7a9bba"}[chunkId] + ".chunk.css";
};